import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityPaddleComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z" fill="none" />
        <path d="M21 14 10 2 3 14h18Z" fill="none" />
        <path d="M10 2v16" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconActivityPaddleComponent.displayName = 'IconActivityPaddle';

const IconActivityPaddle = React.memo(IconActivityPaddleComponent);

export default IconActivityPaddle;
